import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Helmet } from "react-helmet";
import Dashboard from "./pages/Dashboard";
import { Container } from "react-bootstrap";
import CamBalkon from "./pages/CamBalkon";
import Dusakabin from "./pages/Dusakabin";
import Kapi from "./pages/Kapi";
import Panjur from "./pages/Panjur";
import ReactGA from "react-ga4";

function App() {
  return (
    <>
      {/* Helmet ile Google Tag kodu */}
      <Helmet>
        {/* Google Tag Script */}
        <script async src="https://www.googletagmanager.com/gtag/js?id=AW-16782945974"></script>
        <script>
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'AW-16782945974');
          `}
        </script>
      </Helmet>

      {/* Uygulama İçeriği */}
      <Router>
        <Container>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/cam-balkon-sistemleri" element={<CamBalkon />} />
            <Route path="/dusakabin-sistemleri" element={<Dusakabin />} />
            <Route path="/kapi-pencere-sistemleri" element={<Kapi />} />
            <Route path="/panjur-sistemleri" element={<Panjur />} />
          </Routes>
        </Container>
      </Router>
    </>
  );
}

export default App;
